import { CropCategory } from "@/generated/digitalnisklady.cz/graphql";

import { categoryToSlug } from "../marketplace-subcategory.utils";
import { CategoryIcon } from "./category-icon";
import { NavigationCard } from "./navigation-card";

const CategoryCard = ({
  badge,
  category,
  disabled = false,
  label,
}: {
  badge?: string;
  category: CropCategory;
  disabled?: boolean;
  label: string;
}) => {
  const slug = categoryToSlug(category);

  return (
    <NavigationCard
      badge={badge}
      disabled={disabled}
      icon={<CategoryIcon category={category} className="w-6 h-6 shrink-0" />}
      id={category}
      label={label}
      to={slug}
    />
  );
};

export { CategoryCard };
